import { Action as UserAction } from '../actions/user';

const defaultState = {
  name: undefined,
  isFetching: false,
  isCountingFavoriteStations: false,
  isUploadingImage: false,
  imageUploadSuccess: undefined,
  isEnteringContest: false,
  submissionSuccessful: false,
  byName: {},
  address: {},
  tags: {},
  error: undefined,
  isUpdatingMembername: false,
  membernameUpdateError: undefined,
};

export default function userReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case UserAction.MemberInfo.MemberInfoPending:
    case UserAction.MemberInfo.MemberContestInfoPending:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };

    case UserAction.MemberInfo.MemberInfoCompleted:
      return {
        ...state,
        ...body.member,
        isFetching: false,
        byName: {
          ...state.byName,
          [body.member.name]: body.member,
        },
      };

    case UserAction.MemberInfo.MemberInfoFailed:
      return {
        ...state,
        isFetching: false,
        error: 'There was an error retrieving your profile',
      };

    case UserAction.Membername.UpdatePending: {
      return {
        ...state,
        isUpdatingMembername: true,
        membernameUpdateError: undefined,
      };
    }

    case UserAction.Membername.UpdateCompleted: {
      return {
        ...state,
        ...body.member,
        isUpdatingMembername: false,
        byName: {
          [body.member.name]: body.member,
        },
      };
    }

    case UserAction.Membername.UpdateFailed: {
      return {
        ...state,
        isUpdatingMembername: false,
        membernameUpdateError: body.status === 409 ? 'Username taken' : 'There was a problem updating your username',
      };
    }

    case UserAction.Membername.UpdateReset: {
      return {
        ...state,
        isUpdatingMembername: false,
        membernameUpdateError: undefined,
      };
    }

    case UserAction.Membername.UpdateFinished: {
      return {
        ...state,
        tags: {
          ...state.tags,
          generatedMembername: false,
        },
      };
    }

    case UserAction.MemberInfo.MemberContestInfoCompleted:
      return {
        ...state,
        isFetching: false,
        contestProfile: body.member,
      };

    case UserAction.MemberInfo.MemberUploadImagePending:
      return {
        ...state,
        isUploadingImage: true,
      };

    case UserAction.MemberInfo.MemberUploadImageFailed:
      return {
        ...state,
        isUploadingImage: false,
        imageUploadSuccess: false,
      };

    case UserAction.MemberInfo.MemberUploadImageCompleted:
      return {
        ...state,
        isUploadingImage: false,
        imageUploadSuccess: !!body.success,
      };

    default:
      return state;
  }
}
